/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { LoanInstallmentPaymentApiModel } from './loan-installment-payment';
import { LoanNotificationMessageSettingsApiModel } from './loan-notification-message-settings';
import { SpecialAccountTypeApiModel } from './special-account-type';

export interface LoanApiModel {
  /**
   * Loan principal amount (readonly)
   */
  amount?: number | null;
  /**
   * Number of decimal digits in amount value
   */
  amount_decimal_digits?: number | null;
  /**
   * Business ID
   */
  business_id?: string | null;
  /**
   * Notifying the Client about the approval, rejection, or deduction of funds under installment payments
   */
  client_notifications?: number | null;
  /**
   * Loan commission fee amount (readonly)
   */
  commission_amount?: number | null;
  /**
   * Loan created date and time (readonly) (optional)
   */
  created?: string | null;
  /**
   * Currensy ISO code
   */
  currency?: string | null;
  /**
   * Loan first installment payments date (readonly) (optional)
   */
  first_payment_date?: string | null;
  /**
   * Loan ID (readonly)
   */
  id?: string | null;
  installment_payments?: Array<LoanInstallmentPaymentApiModel>;
  /**
   * Loan issued date and time (readonly) (optional)
   */
  issued?: string | null;
  /**
   * Loan first installment payments date (readonly) (optional)
   */
  last_payment_date?: string | null;
  /**
   * Loyalty ID
   */
  loyalty_id?: string | null;
  /**
   * Loyalty title (readonly) (optional)
   */
  loyalty_title?: string;
  /**
   * Loan next installment payments date (readonly) (optional)
   */
  next_payment_date?: string | null;
  notification_settings?: Array<LoanNotificationMessageSettingsApiModel>;
  /**
   * Loan installment payments type
   */
  payment_type?: LoanApiModelPaymentTypeEnum | null;
  /**
   * Loan installment payments number (readonly) (optional)
   */
  payments_number?: number | null;
  /**
   * Loan last processed date and time (readonly) (optional)
   */
  processed?: string | null;
  /**
   * Loan processed/paid principal amount (readonly)
   */
  processed_amount?: number | null;
  /**
   * Loan processed/paid commission fee amount (readonly)
   */
  processed_commission_amount?: number | null;
  /**
   * Loan processed installment payments number (readonly) (optional)
   */
  processed_payments_number?: number | null;
  /**
   * Loan processed/paid total amount including principal and commission fee (readonly)
   */
  processed_total_amount?: number | null;
  /**
   * Loan repaid date and time (readonly) (optional)
   */
  repaid?: string | null;
  /**
   * Special account currency ISO code (readonly) (optional)
   */
  special_account_currency?: string | null;
  /**
   * Special account ID (if transaction payment is \'special-account\')
   */
  special_account_id?: string | null;
  /**
   * Special account title (readonly) (optional)
   */
  special_account_title?: string | null;
  special_account_type?: SpecialAccountTypeApiModel;
  /**
   * Loan status (readonly)
   */
  status?: LoanApiModelStatusEnum | null;
  /**
   * Loan term
   */
  term?: number | null;
  /**
   * Loan term basis
   */
  term_basis?: LoanApiModelTermBasisEnum | null;
  /**
   * Loan total amount including principal and commission fee (readonly)
   */
  total_amount?: number | null;
  /**
   * Loan type
   */
  type?: LoanApiModelTypeEnum | null;
  /**
   * Customer user primary email (readonly) (optional)
   */
  user_email?: string | null;
  /**
   * Customer user external id (if platform support) (readonly) (optional)
   */
  user_external_id?: string | null;
  /**
   * Customer user ID (optional)
   */
  user_id?: string | null;
  /**
   * Public Customer user Name (readonly) (optional)
   */
  user_name?: string | null;
  /**
   * Customer user primary phone number (readonly) (optional)
   */
  user_phone?: string | null;
}
export enum LoanApiModelPaymentTypeEnum {
  Currency = 'currency',
  SpecialAccount = 'special-account'
}
export enum LoanApiModelStatusEnum {
  Created = 'created',
  Approved = 'approved',
  Declined = 'declined',
  DeclinedFirstInstallment = 'declined-first-installment',
  Issued = 'issued',
  Canceled = 'canceled',
  PartiallyRepaid = 'partially-repaid',
  Repaid = 'repaid'
}
export enum LoanApiModelTermBasisEnum {
  Day = 'day',
  Month = 'month',
  Year = 'year'
}
export enum LoanApiModelTypeEnum {
  PaymentInInstallments = 'payment-in-installments'
}
